import React from 'react';
import { translate } from 'react-i18next';
import { StyleSheet, Text, View } from 'react-native';
import { SelectionContainer } from '../../Bookings/components/SelectionContainer';
import Theme, { ThemeType } from '../../theme';
import { defaultScale, scaleText } from '../../utils/scaling';

interface IProps {
  athleteModeSelected: boolean;
  onPress: () => void;
  t: (str: string) => string;
}

export const AthleteModeSelection = translate(['bodyscan'], { wait: true })(
  ({ athleteModeSelected, onPress, t }: IProps) => {
    return (
      <View style={styles.container}>
        <SelectionContainer
          width={defaultScale(85)}
          height={defaultScale(89)}
          style={styles.selectionContainer}
          title={t('standard')}
          titleStyle={styles.title}
          isSelected={!athleteModeSelected}
          onPress={onPress}
          theme={ThemeType.light}
        />
        <SelectionContainer
          width={defaultScale(85)}
          height={defaultScale(89)}
          style={styles.selectionContainer}
          title={t('athlete')}
          titleStyle={styles.title}
          isSelected={athleteModeSelected}
          onPress={onPress}
          theme={ThemeType.light}
        />
      </View>
    );
  },
);

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginTop: defaultScale(20),
  },
  title: {
    fontSize: scaleText(13),
    fontFamily: Theme.Weight700,
  },
  selectionContainer: {
    margin: defaultScale(5),
  },
});
